module.exports = __webpack_public_path__ + "img/td.8c90bcd7.svg";